import {
  isItemRefSet,
  isImageRefSet,
} from '@packages/systems/dynamo/utils/CollectionFieldUtils';

import type {CollectionRecordType as Collection} from '@packages/systems/dynamo/records/CollectionRecord';
import type {FieldType as Field} from '@packages/systems/dynamo/records/Field';

export {
  getBindableFields,
  defineBindablePropertyFromField,
  defineBindablePropertyFromFieldPath,
  toBindingPath,
  sortFields,
  compareFields,
  CUSTOM_FIELDS_TO_QUERY_MAP,
} from './binding-sources';
export type {FieldPath} from './binding-sources';

export {
  defineCollectionTypeReference,
  defineTypeReferenceForReferenceField,
} from './type-references';

export {DynamoWrapperElementMatchers} from './DynamoWrapper-element-matchers';

export {
  createCollectionListQuerySpecification,
  createItemRefSetListQuerySpecification,
  createCollectionTemplatePageQuerySpecification,
  formatGQLField,
} from './query-specifications';

/*
  Returns fields that project relative binding contexts for a collection.

  Relative bindings contexts are determined based on CMS business logic: Any
  direct multi-reference or multi-image fields of a collection can be projected
  as a relative binding context.

  WARNING: This method should only handle use cases that apply to _all_ CMS
  or CMS-like collections. Any gateway-specific edge cases should be handled
  at a callsite for this function.
*/
export function getRelativeBindingContextFields(
  collection: Collection
): Field[] {
  return collection.fields.reduce<Field[]>((fields, field) => {
    if (isProjectingField(field)) {
      fields.push(field);
    }
    return fields;
  }, []);
}

function isProjectingField(field: Field) {
  return isItemRefSet(field) || isImageRefSet(field);
}
